<template>
  <div class="per_box">
    <div class="per_tree">
      <el-input placeholder="输入关键字进行过滤" v-model="filterText"/>
      <div class="per_tree_box">
        <el-tree v-loading="isShow" element-loading-text="拼命加载中" ref="tree2" :filter-node-method="filterNode" :data="oranList" default-expand-all :props="defaultProps" @node-click="handleNodeClick"></el-tree>
      </div>
    </div>
    <div class="per_main">
      <el-form ref="form" :model="listObj" label-width="80px">
         <el-col :span="11">
          <el-form-item label="机构名称:">
            <div class="line_title_name">{{listObj.orgName }}</div>
          </el-form-item>
        </el-col>
         <el-col :span="11">
          <el-form-item label="机构级别:">
            <div class="line_title_name">{{listObj.orgGrade | org_grade}}</div>
          </el-form-item>
        </el-col>
         <el-col :span="11">
          <el-form-item label="机构层级:">
            {{listObj.orgLevel}}
          </el-form-item>
        </el-col>
         <el-col :span="11">
          <el-form-item label="排序号:">
            {{listObj.orgSort}}
          </el-form-item>
        </el-col>
         <el-col :span="11">
          <el-form-item label="机构路径:">
            <div class="line_title_name">{{listObj.orgNamePath}}</div>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    organizationList:{type: Array},
    isShow:{type:Boolean,default: true}
  },
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "label"
      },
      form: {
        name: '',
      },
      oranList:[],
      filterText:'',
      listObj:{},
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree2.filter(val);
    }
  },
  mounted() {
    let vm = this
    setTimeout(()=>{
      if(vm.organizationList){
        vm.isShow = false
      }
      vm.organizationList[0].openId = 1
      vm.oranList = _.cloneDeep(vm.organizationList)
      vm.listObj = vm.oranList[0]
    },1000)
  },
  filters:{
    org_grade (val) {
      switch (val) {
        case 1:
          return '校区';
        case 2:
          return '校级';
        case 3:
          return '区县级';
        case 4:
          return '市级';
        case 5:
          return '省级';
        default:
          return val;
      }
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleNodeClick(val) {
      let vm = this;
      vm.listObj = val
    },
  }
};
</script>
<style lang="less" scoped>
.per_box { min-height: 400px; margin-top: 16px;
  position: relative;
  .per_tree {
    width: 400px;
    top: 0;
    left: 0;
    bottom: 0;
    position: absolute;
    border: 1px solid #e5e7ea;
    padding: 16px;
    .per_tree_box{
      height: 100%;
      overflow-y: auto;
      margin-top: 8px
    }
  }
  .per_main{ margin-left: 416px; overflow: hidden; border: 1px solid #e5e7ea; }
}
.line_title_name{ overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
</style>
<style>
  .per_main>.el-form .el-form-item{ margin-bottom: 0; }
  .per_main>.el-form .el-form-item .el-form-item__label,
  .per_main>.el-form .el-form-item .el-form-item__content{ height:40px; line-height: 40px;}
</style>









// WEBPACK FOOTER //
// src/components/setting/basic_information/permission/common/permission.vue